import * as React from 'react'

import {
  ButtonPrimary,
  DialogUnwrapped,
  SpacerVertical,
  Typography,
  IconBalloonBroken,
  DesignVersionProvider,
  ParticleDesignVersions
} from '@klarna/bubble-ui'

const scrollViewMinHeight = 325
const DEFAULT_TITLE = 'Oh, no. Something went wrong.'
const DEFAULT_TEXT = 'It looks like we\'re having technical issues. We\'re looking into it. Please try again later.'
const DEFAULT_CLOSE_BUTTON_TEXT = 'Close'

interface ErrorComponentProps {
  title?: string
  text?: string
  onClose?: () => void
  closeButtonText?: string
}

const ErrorComponent = ({
  title = DEFAULT_TITLE,
  text = DEFAULT_TEXT,
  onClose,
  closeButtonText = DEFAULT_CLOSE_BUTTON_TEXT
}: ErrorComponentProps) => {
  const buttons = []

  if (onClose) {
    const closeButton = {
      Component: ButtonPrimary,
      props: {
        children: closeButtonText,
        id: 'error-close-button',
        onClick: () => {
          onClose()
        }
      }
    }
    buttons.push(closeButton)
  }

  return (
    <DesignVersionProvider value={ParticleDesignVersions.WAFFLE_LIGHT}>
      <DialogUnwrapped
        onClose={onClose}
        rightIconAriaLabel={closeButtonText}
        onBackgroundClick={onClose}
        klarnaLogo
        captureEscapeKey={true}
        klarnaLogoAccessibilityLabel="Klarna logo"
        footer={buttons}
        id="error-dialog"
      >
        <div style={{ minHeight: scrollViewMinHeight }}>
          <SpacerVertical spaceToken='space/200'/>
          <IconBalloonBroken size={96}/>
          <SpacerVertical spaceToken='space/200' />
          <Typography textToken='text-style/headings/titles/bold/tertiary'>
            {title}
          </Typography>
          <SpacerVertical spaceToken='space/200' />
          <Typography textToken='text-style/text/paragraphs/body/regular'>
            {text}
          </Typography>
          <SpacerVertical spaceToken='space/600' />
        </div>
      </DialogUnwrapped>
    </DesignVersionProvider>
  )
}

export default ErrorComponent
